import { useNavigate } from 'react-router-dom'

export function useViewModeActions() {
  const navigate = useNavigate()

  return {
    setClinicMode: (id: number) => navigate(`/clinic/${id}`),
    setAdMode: (id: number) => navigate(`/ad-supplier/${id}`),
    setProviderMode: (id: number) => navigate(`/provider/${id}`),
    setClinicGroupMode: (id: number) => navigate(`/clinic-group/${id}`),
    setAdSupplierGroupMode: (id: number) => navigate(`/ad-supplier-group/${id}`),
    goBack: () => navigate(-1),
    goHome: () => navigate('/'),
  }
}
